import axios from '../../axios'
import { apiConstants } from '@const/apiConstants'
import UserStore from '@stores/UserStore'
// import { IGetRoomInfo } from './interface';
const URL = {
  queryColumnDetailByPage:
    '/learn/app/clientapi/home/queryColumnDetailByPage.do', // 栏目获取更多
  queryMyCourseList: '/learn/app/clientapi/course/myCoursesList.do', // 我的课程列表
  queryMyBoughtCourseList:
    '/learn/app/clientapi/course/pay/myBoughtCourseList.do',
  queryHomeColumns: '/learn/app/clientapi/course/typeModuleList.do',
  getClassifyList: '/learn/app/clientapi/course/aiHomeCourseClassify.do',
  getCourseList: '/learn/app/clientapi/course/moduleTagCourseFilterList.do',
  getCourseListAll: '/learn/app/clientapi/course/courselist.do',
  queryLearnCardList: '/learn/app/clientapi/learncard/list.do',
  queryLearnCardBindCourses: '/learn/app/clientapi/learncard/newPageCourse.do',
  getPageLiveData: 'learn/app/clientapi/learncard/pageLive.do'
}
interface ICardCourse {
  sid: string
  id: string
  pageNo: number
  pageSize: number
}
export interface IVasOperation {
  os: string
  sid: string
}

export default {
  /**
   * 栏目获取更多
   */
  queryColumnDetailByPage: (id: string, pageNo: number, pageSize: number) => {
    return axios.get(URL.queryColumnDetailByPage, {
      params: {
        id,
        pageNo,
        pageSize,
        ver: apiConstants.VER,
      },
    })
  },

  /**
   * 我的课程列表
   */
  queryMyCourseList: (
    required: number,
    curPage: number,
    numPerPage: number,
    cateId: string
  ) => {
    return axios.get(URL.queryMyCourseList, {
      params: {
        required,
        sortType: 1,
        curPage,
        numPerPage,
        strOs: apiConstants.STR_OS,
        cateId,
      },
    })
  },
  /**
   * 已购课程列表
   */
  queryMyBoughtCourseList: (curPage: number, numPerPage: number) => {
    return axios.get(URL.queryMyBoughtCourseList, {
      params: {
        curPage,
        numPerPage,
        strOs: apiConstants.STR_OS,
        appId: 'com.mlearning.guangqichuanqi',
      },
    })
  },
  /**
   * 频道所有课程的列表
   */
  queryCourseListAll: (curPage: number, lv: string) => {
    return axios.get(URL.getCourseListAll, {
      params: {
        curPage,
        lv,
        isSupportAudioLive: 1,
        numPerPage: 30,
        ver: apiConstants.VER,
      },
    })
  },
  /**
   * 课程分类
   */
  getClassifyList: (homeId: string) => {
    return axios.get(URL.getClassifyList, {
      params: {
        homeId,
        onlyTopLevel: false
      },
    })
  },
  /**
   * 频道-课程列表
   */
  getCourseList: (
    sortType: number,
    moduleTagId: string,
    curPage: number,
    cateId: string
  ) => {
    return axios.get(URL.getCourseList, {
      params: {
        strOs: apiConstants.STR_OS,
        ver: apiConstants.VER,
        numPerPage: 30,
        sortType,
        moduleTagId,
        curPage,
        cateId,
      },
    })
  },
  /**
   * 查询栏目列表
   */
  queryHomeColumns: (homeId?: string) => {
    return axios.get('/learn/app/clientapi/home/loadHome.do', {
      params: {
        ver: '4.2.4',
        homeId,
      },
    })
  },

  /**
   * 查询学习卡列表
   */
  queryLearnCardList: (sid: string) => {
    return axios.get(URL.queryLearnCardList, {
      params: {
        sid,
      },
    })
  },
  /**
   * 查询学习卡绑定的课程列表
   */
  queryLearnCardBindCourses: (params: ICardCourse) => {
    const { sid, id, pageNo, pageSize } = params
    return axios.get(URL.queryLearnCardBindCourses, {
      params: {
        sid,
        id,
        pageNo,
        pageSize,
      },
    })
  },
  // 获取直播类课程
  getPageLiveData: (params: ICardCourse) => {
    const { sid, id, pageNo, pageSize } = params
    return axios.get(URL.getPageLiveData, {
      params: {
        sid,
        id,
        pageNo,
        pageSize,
      },
    })
  },

  // 增值服务
  queryVasOperation2NativeList: (): Promise<any> => {
    return axios.get('/learn/app/clientapi/misc/queryVasOperation2NativeList.do', {
      params: {
        os: apiConstants.STR_OS,
        sid: UserStore.getSid(),
      }
    })
  },

  // 获取登录人员um账号id
  getPersonDetail: (searchedUserId: string): Promise<any> => {
    return axios.get('/learn/app/clientapi/user/personDetail.do', {
      params: { searchedUserId }
    })
  },
}
